import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { ChangeRequestTypes } from "@enums/change-request-types";
import { useMemo } from "react";

type UseChangeRequestTypes = {
  changeRequests: Array<
    Required<{
      changeRequestStatus: ChangeRequestStatusTypes;
      changeRequestType: ChangeRequestTypes;
    }>
  >;
};

export const useChangeRequest = (props: UseChangeRequestTypes) => {
  const { changeRequests } = props;

  const { changeRequestStatus, changeRequestType } = useMemo(() => {
    let changeRequestStatus = null;
    let changeRequestType = null;

    if (changeRequests.length > 0) {
      changeRequestStatus = changeRequests[0].changeRequestStatus;
      changeRequestType = changeRequests[0].changeRequestType;
    }

    return {
      changeRequestStatus,
      changeRequestType,
    };
  }, [changeRequests]);

  return {
    changeRequestStatus,
    changeRequestType,
  };
};
